import {
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithCustomToken,
} from "firebase/auth";

import {
  postObject,
  postSingleObjectToFirebase,
  updateSingleObjectToFirebase,
} from "./firebase-helpers";
import axios from "axios";
import fb from "../plugins/firebase";

const auth = fb.auth;
const BASE_URL = "https://wade-o-lution-default-rtdb.firebaseio.com";

auth.onAuthStateChanged(async (user) => {
  if (user) {
    let token = await user.getIdToken();
    localStorage.setItem("token", token);
    localStorage.setItem("uid", user.uid);
  } else {
    localStorage.removeItem("token");
  }
});


const addUser = async (user) => {
  let userData = user.auth.currentUser;

  let result = await axios
    .put(
      "https://wade-o-lution-default-rtdb.firebaseio.com/users/" +
        user.uid +
        ".json" +
        "?auth=" +
        user.accessToken,
      {
        ...userData,
        firstName: user.firstName,
        lastName: user.lastName,
        company: user.company,
      }
    )
    .then(async (res) => {
      await deleteKey(user.uid, "apiKey");
      await deleteKey(user.uid, "stsTokenManager");
      const company = await postObject(
        {
          name: user.company,
          users: [user.uid],
        },
        "company"
      );
      await updateSingleObjectToFirebase(
        { ...res.data, companyId: company.key },
        "users",
        user.uid
      );
      return res.data;
    })
    .catch((error) => {
      console.log(error);
      return error;
    });
  return result;
};

const getUserLocations = async () => {
  let result = await axios
    .get(
      `${BASE_URL}/users/${auth.currentUser.uid}/location.json?auth=${auth.currentUser.accessToken}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((e) => console.log(e));
  //let result = await getUserData(auth.currentUser.uid)
  return result;
};

const updateUserLocation = async (id, location) => {
  return await axios
    .put(
      `${BASE_URL}/users/${auth.currentUser.uid}/location/${id}.json?auth=${auth.currentUser.accessToken}`,
      location
    )
    .then((res) => {
      return res.data;
    })
    .catch((e) => console.log(e));
};
const addUserLocation = async (location) => {
  await axios
    .post(
      `${BASE_URL}/users/${auth.currentUser.uid}/locations.json?auth=${auth.currentUser.accessToken}`,
      { ...location, active: false }
    )
    .then((res) => console.log(res))
    .catch((e) => console.log(e));
  return await getUserLocations();
};

const deleteKey = async (id, type) => {
  return await axios.delete(
    `https://wade-o-lution-default-rtdb.firebaseio.com/users/${id}/${type}.json`
  );
};
const registerUser = async (data) => {
  return await createUserWithEmailAndPassword(auth, data.email, data.password)
    .then(async (userCredential) => {
      const user = userCredential.user;
      await addUser({
        ...user,
        company: data.companyName,
        firstName: data.firstName,
        lastName: data.lastName,
      });
      return user;
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log({ errorCode, errorMessage });
      return { errorCode, errorMessage };
    });
};

const loginUser = async (email, password) => {
  return await signInWithEmailAndPassword(auth, email, password)
    .then(async (userCredential) => {
      let user = userCredential.user.auth.currentUser;
      console.log(user.uid, "<-user from loginUser");
      const locations = await getUserLocations(user.uid);
      user.locations = locations;
      //await updateUser(user);
      return user;
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      return { errorCode, errorMessage };
    });
};

const logout = async () => {
  //const auth = getAuth();
  return await signOut(auth)
    .then(() => {
      return;
      // Sign-out successful.
    })
    .catch((error) => {
      console.log(error);
      return error;
      // An error happened.
    });
};

const loginWithToken = async (token) => {
  return await signInWithCustomToken(auth, token)
    .then((res) => {
      console.log(res, "<-login");
      return res;
    })
    .catch((e) => {
      console.log(e);
      return e;
    });
};

const getUserData = async (uid) => {
  return await axios
    .get(`${BASE_URL}/users/${uid}.json`)
    .then((res) => {
      return res.data;
    })
    .catch((e) => console.log(e));
};

export default {
  getUserData,
  addUser,
  registerUser,
  loginUser,
  logout,
  loginWithToken,
  addUserLocation,
  auth,
  getUserLocations,
  
  updateUserLocation,
};
